import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { cards } from '../../../../constants';
import { getDaysUntil } from '../../../Utils';
import { ExpireMessage } from '../PerkDrawer/PerkListComponents';
var cardConstants = cards.OfferChallenges;
// Update ExpireAlert to accept a 'challenge' prop
export var ExpireAlert = function (_a) {
    var challenge = _a.challenge;
    var AlertComponent = function (_a) {
        var hasError = _a.hasError;
        if (hasError || !challenge) {
            return (React.createElement(Alert, { status: "error" },
                React.createElement("span", { className: "sui-inline-block sui-mr-1" }, cardConstants.caption.error[0]),
                React.createElement("span", { className: "sui-inline-block" }, cardConstants.caption.error[1])));
        }
        var diff = getDaysUntil(challenge.challengeEndDate);
        return diff <= 4 ? (React.createElement(Alert, { status: "warning", id: "challengesCard-alert" },
            React.createElement(ExpireMessage, { numOfDays: diff }))) : (React.createElement(Alert, { status: "info", id: "challengesCard-alert" },
            "Expires ", challenge === null || challenge === void 0 ? void 0 :
            challenge.challengeEndDate));
    };
    return (React.createElement("div", { className: "sui-pt-5 sm:sui-pt-0 sui-text-base" },
        React.createElement(AlertComponent, { hasError: !challenge })));
};
